<interacta-dialog
    [contentOverflowAuto]="false"
    [isOpen]="data().isOpen"
    [size]="'small'"
    (closed)="close()"
>
    <h2 class="typo-t6" title>
        {{ 'SHARED.GROUP_DETAILS.GROUP_DETAILS' | translate }}
    </h2>

    @let _group = group();

    @if (!data().isFetching && _group) {
        <div class="flex flex-col gap-y-8" subtitle>
            <interacta-users-group
                [canClick]="false"
                [group]="_group"
                [matTooltip]="_group.fullName"
                [showInfo]="true"
                [size]="'medium'"
            />

            @if (_group.description) {
                <p class="line-clamp-3 typo-sm whitespace-pre-line italic">
                    {{ _group.description }}
                </p>
            }
            <interacta-separator class="mb-16" />
        </div>
    }

    @if ((_group?.membersCount ?? 0) > N_MEMBERS_TO_SHOW && showMoreMembers()) {
        <interacta-input-search
            class="mb-16"
            search
            [control]="search"
            [iconPosition]="'right'"
        />
    }

    @if (!data().isFetching && _group) {
        <div class="flex min-h-360 flex-col gap-y-16 overflow-hidden" content>
            <!-- MEMBERS PREVIEW -->
            @if (showMoreMembers()) {
                <div
                    class="h-full overflow-y-auto px-2 py-4"
                    interactaScrollTracker
                    [wheelScrollOnly]="true"
                    (scrolled)="onScroll($event, members())"
                >
                    @if (
                        members().isFetching &&
                        members().nextPageToken.tag === 'firstLoading'
                    ) {
                        <interacta-member-list-placeholder />
                    } @else {
                        <ul
                            #listElement
                            class="flex grow flex-col gap-y-16 empty:hidden"
                        >
                            @for (member of members().list; track member.id) {
                                <li
                                    [attr.aria-setsize]="
                                        members().totalCount || -1
                                    "
                                >
                                    <ng-template
                                        *ngTemplateOutlet="
                                            memberTemplate;
                                            context: {
                                                member,
                                            }
                                        "
                                    />
                                </li>
                            }
                        </ul>
                        @if (members().nextPageToken.tag === 'regularLoading') {
                            <interacta-load-more
                                class="pt-16"
                                [autoFocusLoader]="true"
                                [isLoading]="members().isFetching"
                                [label]="'UI.SHOW_MORE_UNCOUNT' | translate"
                                [size]="'regular'"
                                (loadMore)="
                                    fetchNextMembers(members(), listElement)
                                "
                            />
                        }
                    }
                </div>
            } @else {
                @if (members().isFetching) {
                    <interacta-member-list-placeholder />
                } @else {
                    @if (_group.deleted) {
                        <p class="typo-sm">
                            {{
                                'SHARED.GROUP_DETAILS.DELETED_GROUP' | translate
                            }}
                        </p>
                    }

                    @if (_group.membersCount) {
                        <ul
                            class="flex h-full flex-col gap-y-16 overflow-y-auto pe-8"
                        >
                            @for (member of members().list; track member.id) {
                                <li
                                    class="flex items-center justify-between gap-x-8"
                                >
                                    <ng-template
                                        *ngTemplateOutlet="
                                            memberTemplate;
                                            context: {
                                                member,
                                            }
                                        "
                                    />
                                    @if ($last && remainingMembers() > 0) {
                                        <button
                                            class="shrink-0 typo-sm text-palette-secondary"
                                            type="button"
                                            (click)="loadMoreMembers()"
                                        >
                                            {{
                                                remainingMembers()
                                                    | i18nPlural
                                                        : {
                                                              '=1': 'SHARED.GROUP_DETAILS.OTHER_MEMBERS_SINGULAR',
                                                              other: 'SHARED.GROUP_DETAILS.OTHER_MEMBERS_PLURAL',
                                                          }
                                                    | translate
                                                        : {
                                                              remainingMembers:
                                                                  remainingMembers(),
                                                          }
                                            }}
                                        </button>
                                    }
                                </li>
                            }
                        </ul>
                    }
                }
            }
        </div>
    } @else {
        <div class="m-auto flex h-200 items-center" content>
            <interacta-loader [size]="'large'" />
        </div>
    }

    @if (_group && showEditButton()) {
        <interacta-dialog-buttons [showSeparator]="true">
            <button
                interacta-dialog-button
                type="button"
                [label]="'SHARED.GROUP_DETAILS.EDIT_GROUP' | translate"
                [style]="'text-primary'"
                (click)="edit(_group.id)"
            ></button>
        </interacta-dialog-buttons>
    }
</interacta-dialog>

<ng-template #memberTemplate let-member="member">
    @if (isAdmin()) {
        <interacta-member-admin class="line-clamp-1" [member]="member" />
    } @else {
        <interacta-member
            class="line-clamp-1"
            [member]="member"
            [size]="'small'"
        />
    }
</ng-template>
